/* eslint-disable */

function baseSixtyFour() {

  /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */
  /*  Taken from http://www.movable-type.co.uk/scripts/base64.js */
  /*  Base64 class: Base 64 encoding / decoding (c) Chris Veness 2002-2011                          */
  /*  note: depends on Utf8 class
  /*  http://www.movable-type.co.uk/scripts/base64.js */
  /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */

  var base64Code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

  /**
   * Decode string from Base64, as defined by RFC 4648 [http://tools.ietf.org/html/rfc4648]
   * (instance method extending String object). As per RFC 4648, newlines are not catered for.
   *
   * @param {String} str The string to be decoded from base-64
   * @param {Boolean} [utf8decode=false] Flag to indicate whether str is Unicode string to be decoded
   *   from UTF8 after conversion from base64
   * @returns {String} decoded string
   */
  function decode(str, utf8decode) {

    utf8decode = (typeof utf8decode == 'undefined') ? false : utf8decode;
    var o1, o2, o3, h1, h2, h3, h4, bits, d = [], plain, coded;
    var b64 = base64Code;

    coded = utf8decode ? Utf8.decode(str) : str;

    for (var c = 0; c < coded.length; c += 4) {  // unpack four hexets into three octets

      h1 = b64.indexOf(coded.charAt(c));
      h2 = b64.indexOf(coded.charAt(c + 1));
      h3 = b64.indexOf(coded.charAt(c + 2));
      h4 = b64.indexOf(coded.charAt(c + 3));

      bits = h1 << 18 | h2 << 12 | h3 << 6 | h4;

      o1 = bits >>> 16 & 0xff;
      o2 = bits >>> 8 & 0xff;
      o3 = bits & 0xff;

      d[c / 4] = String.fromCharCode(o1, o2, o3);
      // check for padding
      if (h4 == 0x40) d[c / 4] = String.fromCharCode(o1, o2);
      if (h3 == 0x40) d[c / 4] = String.fromCharCode(o1);

    }

    plain = d.join('');  // join() is far faster than repeated string concatenation in IE

    return decodeURIComponent(escape(utf8decode ? Utf8.decode(plain) : plain))

  }

  /**
   * Decode string from Base64URL, as defined by RFC 4648.
   *
   * @param {String} str The string to be decoded from base-64URL.
   * @returns {String} decoded string.
   */
  function urlDecode(str) {

    str = urlSpecialChar(str);

    if (atob) {

      try {

        return atob(str);

      } catch (e) {

        return '';

      }

    }

    return decode(addPadding(str));

  }

  /**
   * Decode string from Base64URL into HEX, as defined by RFC 4648.
   *
   * @param {String} str The string to be decoded from base-64URL.
   * @returns {String} decoded HEX string.
   */
  function urlDecodeToHex(str) {

    let raw = urlDecode(str);
    let hex = '';
    let i;

    for ( i = 0; i < raw.length; i++ ) {

      let _hex = raw.charCodeAt(i).toString(16);

      hex += (_hex.length === 2 ? _hex : '0' + _hex);

    }

    return hex;

  }

  /**
   * Add necessary padding to string.
   *
   * @param {String} str The string to be padded.
   * @returns {String} The string with padding.
   */
  function addPadding(str) {

    while ((str.length % 4) !== 0) {

      str = str + '=';

    }

    return str;

  }

  /**
   * Special URL decode characters substitution for base64 decode.
   *
   * @param {String} str The string with URL friendly characters.
   * @returns {String} The string to base64 decode.
   */
  function urlSpecialChar(str) {

    return str.replace('-', '+').replace('_', '/');

  }

  return {

    decode: (str => decode(str)),
    urlDecode: (str => urlDecode(str)),
    urlDecodeToHex: (str => urlDecodeToHex(str)),
    addPadding: (str => addPadding(str)),
    urlSpecialChar: (str => urlSpecialChar(str))

  };

}

export default baseSixtyFour;



// WEBPACK FOOTER //
// ./src/angular-services/basesixtyfour.service.js